//
//
//
//
//
//

import FlowStep from "@/0/components/comForm/comFlowStep";
import FormResult from "@/0/components/comForm/comFormResult";

export default {
  components: {
    "flow-step": FlowStep,
    "form-result": FormResult
  },
  data() {
    return {
      isFormInit: false,

      orderItem : null,

      stepConfig: {
        curStep: 2,
        list: ["填报活动销量", "提交成功,等待审核", "核销通过"],
        color: "rgb(81,170,56)"
      },
      
      resultConfig: {
        SystemCode: "",
        img: "",
        mainColor: "rgb(81,170,56)",
        btnList: [
          {
            text: "1.查看提报详情",
            link: "/Sms/ShopActivitySalesCheckOrder/Detail?",
            isRouter: true,
          },
          {
            text: "2.活动提报列表",
            link: "/Sms/ShopActivitySalesCheckOrder/Index",
            isRouter: true
          },
          {
            text: "3.继续活动提报",
            link: "/Sms/ShopActivitySalesCheckOrder/Create",
            isRouter: true
          },
          {
            text: "关闭页面",
            isClose: true
          }
        ]
      }
    };
  },
  async created() {

    var openId = this.$route.query.openId;
    if(!openId){
      this.$msg.alert("无效操作.");
      return;
    }
    this.$msg.showLoading("正在验证...");
    var url = "/mSmsApi/ShopActivitySalesCheckOrder/Get";
    var postData = {
      OpenId : openId
    };
    let { data: result } = await this.$http({
      method: "post",
      url: url,
      data : postData,
    });

    this.$msg.hideLoading();
    if (result.state == 1) {
      this.isFormInit = true;
      this.$msg.succ("核验通过");
      this.orderItem = result.data;
      this.resultConfig.SystemCode = this.orderItem.OrderNo;
      this.resultConfig.btnList[0].link = "/Sms/ShopActivitySalesCheckOrder/Detail?openId=" + this.orderItem.OpenId;
      return;
    }
    this.$msg.alert(result.msg);
    console.log(result);
    
  },
  methods: {}
};
